import { FormGroup, FormControl,Validators } from '@angular/forms';
import { Component, Input, Optional, Host} from '@angular/core';
import { SatPopover } from '@ncstate/sat-popover';
@Component({
  selector: 'app-inline-black-list',  
  styleUrls: ['./inline-black-list.component.scss'],
  template: `
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="mat-subheading-2">Razón</div>
    
    <mat-form-field class="example-full-width" appearance="outline">
                            <mat-label>Razón</mat-label>
                            <textarea matInput placeholder="Maximum 500 characters..."
                                formControlName="Observaciones"></textarea>
                        </mat-form-field>

    <div class="actions">
      <button mat-button type="button" color="primary" (click)="onCancel()">Cancelar</button>
      <button mat-button type="submit" color="primary" [disabled]="form.invalid">Guardar</button>
    </div>
  </form>
`
})
export class InlineBlackListComponent {
  @Input()
  get value(): string { return this._value; }
  set value(x: string) {}
  private _value = '';
  form: FormGroup;

  constructor(@Optional() @Host()
   public popover: SatPopover) {

    this.form = new FormGroup({
      "Observaciones" :new FormControl("",Validators.required),
    });
    }


  onSubmit() {
    if (this.popover) {
      this.popover.close(this.form.controls['Observaciones'].value);
    }
  }

  onCancel() {
    if (this.popover) {
      this.popover.close();
    }
  }
}
